module.exports = __webpack_public_path__ + "img/73.9.TU.8d3ecb26.png";